import { render } from "./Details.vue?vue&type=template&id=0d33fbb2&scoped=true"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"

import "./Details.vue?vue&type=style&index=0&id=0d33fbb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d33fbb2"

export default script